import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styles: []
})
export class MainLayoutComponent implements OnInit {
  currentUrl: string;

  constructor() { }

  ngOnInit() {
  }
  onNavigationChange(event: string) {
    this.currentUrl = event;
  }

}
